import { protectedRoutes } from './app';
import type { AppRouteConfig } from './types';

export function preloadRoute(path: string) {
  const pathname = path.split(/[?#]/, 1)[0];
  function visit(routes: AppRouteConfig[]): void {
    for (const route of routes) {
      if (route.path === pathname && route.component?.preload) {
        // Speculative failures must not replace the current page or poison retry.
        void route.component.preload().catch(() => undefined);
      }
      if (route.routes) visit(route.routes);
    }
  }
  visit(protectedRoutes);
}
